import { createSelector } from "reselect";

import { CourseId } from "../models/state/courses/Courses";
import { SectionId } from "../models/state/sections/Sections";
import { makeGetSectionNumber } from "./getSectionNumber";
import { getSectionTitle } from "./state";

type State = any;

export function makeGetSectionTitleWithNumber(
  courseId: CourseId,
  sectionId: SectionId
): (arg0: State) => string {
  const getSectionNumber = makeGetSectionNumber(courseId, sectionId);
  return createSelector(
    getSectionNumber,
    (state: any) => getSectionTitle(state, sectionId),
    (sectionNumber, sectionTitle) => `${sectionNumber} ${sectionTitle}`
  );
}
